import { SelectInput } from "@components/ui/Field"
import { cn } from "@lib/cn"
import { useTranslation } from "react-i18next"

import { LOCALES, LOCALE_LABELS, type Locale } from "@/i18n/config"

/**
 * Compact locale select for chrome that has no room for a labelled field
 * (the login page). Preferences uses `Segmented` instead, where the two
 * locales sit side by side.
 */
export function LanguageSwitcher({ className }: { className?: string }) {
  const { i18n, t } = useTranslation("common")
  return (
    <SelectInput
      value={i18n.language}
      onChange={(e) => void i18n.changeLanguage(e.target.value as Locale)}
      aria-label={t("language.label")}
      className={cn("w-auto", className)}
    >
      {LOCALES.map((l) => (
        <option key={l} value={l}>
          {LOCALE_LABELS[l]}
        </option>
      ))}
    </SelectInput>
  )
}
